// extracted by mini-css-extract-plugin
export var linkText = "_qf-0";